import type { FlexItemProps } from './Flex.types';

const isDataAttribute = (name: string): name is `data-${string}` => name.startsWith('data-');

export const getDataAttributes = (props: FlexItemProps): Record<string, FlexItemProps[`data-${string}`]> => {
  const attributes: Record<string, FlexItemProps[`data-${string}`]> = {};

  Object.keys(props).forEach((name) => {
    if (isDataAttribute(name)) {
      attributes[name] = props[name];
    }
  });

  return attributes;
};
